import { Permiso } from "../modulos/admin/models/permiso";
import { Rol } from "../modulos/admin/models/rol";
import { Ambiente } from "../modulos/catalogos-proces/models/ambiente";

export class Usuario {
    token: string;
    idSprUsuario: number;
    idSprRol: number;
    idSprNivel: number;
    idSprAmbiente: number;
    nombres: string;
    userAmbiente: string;
    nombreUnidad: string;


    constructor() {
        this.token = '';
        this.idSprUsuario = 0;
        this.idSprRol = 0;
        this.idSprNivel = 0;
        this.idSprAmbiente = 0;
        this.nombres = '',
        this.userAmbiente = ''
        this.nombreUnidad = ''
    }
}


export interface UsuarioRedux {
    idSprUsuario: number
    cedula: string
    correoElectronico: string
    nombreUsuario: string
    roles: Rol[]        
  }
    
  
  export interface Aplicacion {
    idSprAplicacion: number
    nombreApp?: string
    permisos?: Permiso[]
  }
  